import React, { useEffect, useState } from 'react'
import PieChart from '../PieChart';
import { addMinutes, format, formatDistanceToNowStrict } from 'date-fns'

import { formatDuration, intervalToDuration } from 'date-fns'
import { useWeb3React } from '@web3-react/core';
import PuffLoader from "react-spinners/PuffLoader";
import { isMobile } from 'react-device-detect';
import { Button } from 'react-bootstrap';
import RangeSlider from '../RangeSlider';


function PoolCardView(props: any) {
    const { account } = useWeb3React()
    const [poolState, setPoolState] = useState<'TBA' | 'WHITLIST_WILL_OPEN' | 'WHITLIST_IS_ON' | 'POOL_WILL_OPEN' | 'POOL_IS_ON' | 'FILLED' | 'CLOSED'>()
    const [isWithdrawOpen, setIsWithdrawOpen] = useState(false);
    const [isTotalVestedOpen, setIsTotalVestedOpen] = useState(false);
    const [isLocalDateOpen, setIsLocalDateOpen] = useState(false);
    function nFormatter(num: number, digits: number) {
        const lookup = [
            { value: 1, symbol: "" },
            { value: 1e3, symbol: "k" },
            { value: 1e6, symbol: "M" },
            { value: 1e9, symbol: "G" },
            { value: 1e12, symbol: "T" },
            { value: 1e15, symbol: "P" },
            { value: 1e18, symbol: "E" }
        ];
        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var item = lookup.slice().reverse().find(function (item) {
            return num >= item.value;
        });
        return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
    }
    const override = `
        display: block;
        margin: 0 auto;
        border-color: red;
    `;

    useEffect(() => {
        console.log(props)
        try {
            if (props.openTime === 0) {
                setPoolState('TBA')
            } else if (Number(props.whitelistingOpenTime) > Date.now()) {
                setPoolState('WHITLIST_WILL_OPEN')
            } else if (Number(props.whitelistingOpenTime) < Date.now() && Number(props.whitelistingCloseTime) >= Date.now()) {
                setPoolState('WHITLIST_IS_ON')
            } else if (Number(props.whitelistingCloseTime) <= Date.now() && Number(props.openTime) >= Date.now()) {
                setPoolState('POOL_WILL_OPEN')
            } else if (Number(props.openTime) < Date.now() && Number(props.closeTime) > Date.now()) {
                setPoolState('POOL_IS_ON')
            } else if (Number(props.closeTime) < Date.now()) {
                setPoolState('CLOSED')
            }
            if (props.openTime !== 0 && Number(props.closeTime) < Date.now()) {
                setPoolState('FILLED')
            }
            if (props.openTime !== 0 && (Number(props.totalCollected) + 100) >= props.totalRaise) {
                setPoolState('FILLED')
            }
        } catch (e) {
            console.log(e)
        }

    }, [props])

    useEffect(() => {
        console.log(props.title, poolState)
    }, [poolState])

    return (
        <>
            <div className="pool-card">
                <div className="pool-card-status">
                    {poolState === 'TBA' && (
                        <h6 className="m-0 text-xxs">
                            TBA
                        </h6>
                    )}
                    {poolState === 'WHITLIST_WILL_OPEN' && (
                        <h6 className="m-0 text-xxs">
                            Whitelist Opens In {formatDuration(intervalToDuration({ start: new Date(Number(props.whitelistingOpenTime)), end: new Date() }), { format: ['years', 'months', 'weeks', 'days', 'hours', 'minutes'], delimiter: ' ' })}
                        </h6>
                    )}
                    {poolState === 'WHITLIST_IS_ON' && (
                        <h6 className="m-0 text-xxs">
                            Whitelist Closes In {formatDuration(intervalToDuration({ start: new Date(), end: new Date(Number(props.whitelistingCloseTime)) }), { format: ['years', 'months', 'weeks', 'days', 'hours', 'minutes'], delimiter: ' ' })}
                        </h6>
                    )}
                    {poolState === 'POOL_WILL_OPEN' && (
                        <h6 className="m-0 text-xxs">
                            Opens In {formatDuration(intervalToDuration({ start: new Date(Number(props.openTime)), end: new Date() }), { format: ['years', 'months', 'weeks', 'days', 'hours', 'minutes'], delimiter: ' ' })}
                        </h6>
                    )}
                    {poolState === 'POOL_IS_ON' && (
                        <h6 className="m-0 text-xxs">
                            Open
                        </h6>
                    )}
                    {poolState === 'FILLED' && (
                        <h6 className="m-0 text-xxs">
                            Filled
                        </h6>
                    )}
                    {poolState === 'CLOSED' && (
                        <h6 className="m-0 text-xxs">
                            Closed
                        </h6>
                    )}
                </div>
                <div className="pool-card-body">
                    <div className='upper-container'>
                        <div className="pool-brand-view row d-flex justify-content-between align-items-center">
                            <div className="col-lg-12 col-sm-12 pool-branding d-flex align-items-center">
                                <div className="row justify-content-center pool-brand-container">
                                    <div className="pool-img col-3 ">
                                        <div className='pool-img-chain-container'>
                                            <img src={props.logo} />
                                            <div className='token-ticker text-center'>
                                                <h6 className='chain-name'>{props.chainName}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pool-title col-8 ">
                                        <h4 className="m-0">{props.title}</h4>
                                        <p className="m-0 text-xs">{props.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pool-detail-view d-flex justify-content-between align-items-center">
                            <div className="pool-card-detail">
                                <div className="account-details-container col">
                                    <div className='claim-dashboard-item d-flex'>
                                        <div className={`first-container flip-container ${isWithdrawOpen ? "flipped" : ""}`}>
                                            <div className="flipcard-body">
                                                <div className="front-container">
                                                    <div className="total-withdrawn d-flex align-items-center">
                                                        <img className="flip-icon" onClick={() => setIsWithdrawOpen(!isWithdrawOpen)} src="../images/icons/right.svg" />
                                                        {/* <span className='withdraw-icon mb-2'>
                                                        <img className="icon-details" src="../images/icons/unlocked.png" />
                                                    </span> */}
                                                        <span className='title'>Token Price</span>
                                                        <span className='withdrawn-amount'>1 {props.symbol} = ${(props.price).toFixed(3)}</span>
                                                    </div>
                                                </div>
                                                <div className="back-container">
                                                    <div className="total-withdrawn d-flex align-items-center">
                                                        <img className="flip-icon" onClick={() => setIsWithdrawOpen(!isWithdrawOpen)} src="../images/icons/right.svg" />
                                                        {/* <span className='withdraw-icon mb-2'>
                                                        <img className="icon-details" src="../images/icons/hourglass.png" />
                                                    </span> */}
                                                        <span className='title'> {isMobile ? "Accepted Cur." : "Accepted Currency"}</span>
                                                        <span className='withdrawn-amount'>BSC-USDT</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`second-container flip-container ${isTotalVestedOpen ? "flipped" : ""}`}>
                                            <div className="flipcard-body">
                                                <div className="front-container">
                                                    <div className="total-withdrawn d-flex align-items-center">
                                                        <img className="flip-icon" onClick={() => setIsTotalVestedOpen(!isTotalVestedOpen)} src="../images/icons/right.svg" />
                                                        {/* <span className='withdraw-icon mb-2'>
                                                        <img className="icon-details" src="../images/icons/padlock.png" />
                                                    </span> */}
                                                        <span className='title'>Total Raise</span>
                                                        <span className='withdrawn-amount'>{Number(props.totalRaise).toLocaleString()} USDT</span>
                                                    </div>
                                                </div>
                                                <div className="back-container">
                                                    <div className="total-withdrawn d-flex align-items-center">
                                                        <img className="flip-icon" onClick={() => setIsTotalVestedOpen(!isTotalVestedOpen)} src="../images/icons/right.svg" />
                                                        {/* <span className='withdraw-icon mb-2'>
                                                        <img className="icon-details" src="../images/icons/percentage.png" />
                                                    </span> */}

                                                        <span className='title'>Token For Sale</span>
                                                        <span className='withdrawn-amount'>{nFormatter(props.tokenForSale, 1)} {props.symbol}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="account-details-container date-details-container col">
                                    <div className='claim-dashboard-item d-flex flex-lg-row'>
                                        <div className={`first-container flip-container ${isLocalDateOpen ? "flipped" : ""}`}>
                                            <div className="flipcard-body">
                                                <div className="front-container">
                                                    <div className="total-withdrawn d-flex align-items-center">
                                                        <img className="flip-icon" onClick={() => setIsLocalDateOpen(!isLocalDateOpen)} src="../images/icons/right.svg" />
                                                        <span className='mb-0 text-left'>IDO Date: {props.openTime === 0 ? (isMobile ? "To be announced" : "To be announced, stay tuned!") : (isMobile ? format(addMinutes(new Date(props.openTime), new Date(props.openTime).getTimezoneOffset()), 'dd/MM/yyy, hh:mm:ss') : (new Date(props.openTime).toUTCString()).replace('GMT', 'UTC'))}</span>
                                                        {/* <span className='withdrawn-amount'>{(1 / props.price).toFixed(4)} {props.symbol}</span> */}
                                                    </div>
                                                </div>
                                                <div className="back-container">
                                                    <div className="total-withdrawn d-flex align-items-center">
                                                        <img className="flip-icon" onClick={() => setIsLocalDateOpen(!isLocalDateOpen)} src="../images/icons/right.svg" />
                                                        <span className='mb-0'>Listing Date: {props.listingTime === 0 ? (isMobile ? "To be announced" : "To be announced, stay tuned!") : (isMobile ? format(addMinutes(new Date(props.listingTime), new Date(props.listingTime).getTimezoneOffset()), 'dd/MM/yyy, hh:mm:ss') : (new Date(props.listingTime).toUTCString()).replace('GMT', 'UTC'))}</span>
                                                        {/* <span className='withdrawn-amount'>{props.price} USDT</span> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pool-card-social">
                                <a className='website' href={props.website} target='_blank'>
                                    <div className="social-item d-flex flex-column align-items-center">
                                        <img alt="social website" className="social-icon" src="../images/social-website.png"></img>
                                    </div>
                                </a>
                                <a className='twitter' href={"https://twitter.com/" + props.twitter} target='_blank'>
                                    <div className="social-item d-flex flex-column align-items-center">
                                        <img alt="social twitter" className="social-icon" src="../images/social-twitter.svg"></img>
                                    </div>
                                </a>
                                <a className="telegram" href={"https://telegram.me/" + props.telegram} target='_blank'>
                                    <div className="social-item d-flex flex-column align-items-center">
                                        <img alt="social telegram" className="social-icon" src="../images/social-telegram.svg"></img>
                                    </div>
                                </a>
                                <a className='pitchdeck' href={props.pitchDeck} target='_blank'>
                                    <div className="social-item d-flex flex-column align-items-center">
                                        <img alt="social pitchdeck" className="social-icon" src="../images/social-deck.png"></img>
                                    </div>
                                </a>


                            </div>
                        </div>
                    </div>
                    <div className='pool-progress-view'>
                        {(poolState == 'TBA' || poolState == 'WHITLIST_WILL_OPEN' || poolState == 'WHITLIST_IS_ON') && (

                            <>
                                <div className='d-flex align-items-center'>
                                    <div className={ poolState == 'WHITLIST_IS_ON' ? "w-100 progress-bar-container" : "w-100" }>
                                        <div>
                                            <RangeSlider
                                                className="range-slider"
                                                custom={true}
                                                // value={0}
                                                value={props.exclusivePoolDetails.allocationPercentage}
                                                type='range'
                                                readOnly={true}
                                            />
                                        </div>
                                        {/* //conditional */}
                                        <div className='d-flex justify-content-between'>
                                            <small className='mb-0'>Exculsive: {props.exclusivePoolDetails.allocationPercentage}%</small>
                                            <small className='mb-0'>{props.communityPoolDetails.allocationPercentage}%: Community</small>
                                        </div>
                                    </div>
                                    {poolState == 'WHITLIST_IS_ON' && (
                                        <div>
                                            <a className='btn btn-brand' href="https://blockius.typeform.com/deadknight" target={"_blank"}>Whitelist</a>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                        {(poolState == 'POOL_WILL_OPEN' || poolState == 'POOL_IS_ON' || poolState == 'FILLED' || poolState == 'CLOSED') && (
                            <>
                                <div>
                                    <RangeSlider
                                        className="range-slider"
                                        custom={true}
                                        // value={0}
                                        value={props.totalCollected > 0 ? props.totalCollected / props.totalRaise * 100 : 0}
                                        type='range'
                                        readOnly={true}
                                    />
                                </div>
                                {/* //conditional */}
                                <div className='d-flex justify-content-between'>
                                    <small className='mb-0'>{props.totalCollected > 0 ? Number(props.totalCollected / props.totalRaise * 100).toFixed(2) : 0} %</small>
                                    <div className='pool-type'><h6 className='mb-0'>{props.isExculsivePool ? "Exclusive" : "Community"}</h6></div>
                                    <small className='mb-0'>{Number(props.totalCollected).toLocaleString()} / {Number(props.totalRaise).toLocaleString()} USDT</small>
                                </div>
                            </>
                        )}


                    </div>
                    {/* {(poolState === 'WHITLIST_IS_ON' || poolState === 'WHITLIST_WILL_OPEN') && (
                            <div className='col-lg-3 whitelist-mobile  col-md-12 pt-16'>
                                <div className='whitelist-container'>
                                    <div className="rate ido-date d-flex">
                                        <p className="text-sm m-0">IDO: </p>
                                        <h6 className="text-sm m-0 ml-4">{new Date(props.openTime).toLocaleDateString()}</h6>
                                        
                                    </div>
                                    <div className="col d-flex flex-column-reverse mt-16 register-container">
                                        {props.whitelistingLink && poolState === 'WHITLIST_IS_ON' && (
                                            <a className="button button-primary whitelist-button" href={props.whitelistingLink} target="_blank">
                                                WHITELIST
                                            </a>
                                        )}
                                        {!props.whitelistingLink || poolState === 'WHITLIST_WILL_OPEN' && (
                                            <a className="button button-primary whitelist-button disabled" href={"#"} target="_blank">
                                                WHITELIST
                                            </a>
                                        )}
                                        <p className="text-xs m-0 register-now-text">Register Now</p>
                                    </div>
                                </div>
                            </div>
                        )} */}
                    {/* {(poolState !== 'WHITLIST_IS_ON' && poolState !== 'WHITLIST_WILL_OPEN') && !isMobile && !account && <div className="col-lg-3 col-sm-12">
                            <PuffLoader color={"#C2EAFF"} loading={true} css={override} />
                            <p className="connect-wallet-notice-pie">Connect Wallet to see progress</p>
                        </div>}
                        {(poolState !== 'WHITLIST_IS_ON' && poolState !== 'WHITLIST_WILL_OPEN') && !isMobile && account && <div className="col-lg-3 col-sm-12 pl-0">
                            <PieChart filled={Number(props.totalCollected / props.totalRaise * 100).toFixed(2)}></PieChart>
                        </div>} */}

                </div>
            </div>
        </>
    )
}

export default PoolCardView